import { Tabs } from 'antd';
import React from 'react';
import { GetResultsTableProps } from '../find-taxpayer-service.type';
import { GetResultsTable } from './get-results-table';
import { ResultsSummary } from './results-summary';

function Results({
    tableData,
    translations,
    type,
    values,
    total,
    lang,
    paymentData,
}: GetResultsTableProps) {
    return (
        <>
            {tableData.length > 1 ? (
                <>
                    <ResultsSummary
                        translations={translations}
                        resultsCount={tableData.length}
                        total={total}
                    />
                    <Tabs
                        defaultActiveKey="1"
                        tabPosition="left"
                        tabBarStyle={{ width: '20rem' }}
                        size="large"
                        items={tableData?.map((item, i) => {
                            const id = String(i + 1);
                            return {
                                label: item?.iinBin || item?.name || 'Элемент',
                                key: id,
                                children: (
                                    <GetResultsTable
                                        noResNumber
                                        item={item}
                                        translations={translations}
                                        paymentData={paymentData}
                                        type={type}
                                        lang={lang}
                                        values={values}
                                    />
                                ),
                            };
                        })}
                    />
                </>
            ) : (
                <GetResultsTable
                    item={tableData[0]}
                    translations={translations}
                    paymentData={paymentData}
                    type={type}
                    values={values}
                    lang={lang}
                />
            )}
        </>
    );
}

export default Results;
